var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tablet-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.7995 15.1833H10.8078M6.79948 18.9333H14.7995C15.7329 18.9333 16.1996 18.9333 16.5561 18.7516C16.8697 18.5918 17.1247 18.3369 17.2845 18.0233C17.4661 17.6667 17.4661 17.2 17.4661 16.2666V4.93327C17.4661 3.99985 17.4661 3.53314 17.2845 3.17662C17.1247 2.86301 16.8697 2.60805 16.5561 2.44826C16.1996 2.2666 15.7329 2.2666 14.7995 2.2666H6.79948C5.86606 2.2666 5.39935 2.2666 5.04283 2.44826C4.72922 2.60805 4.47426 2.86301 4.31447 3.17662C4.13281 3.53314 4.13281 3.99985 4.13281 4.93327V16.2666C4.13281 17.2 4.13281 17.6667 4.31447 18.0233C4.47426 18.3369 4.72922 18.5918 5.04283 18.7516C5.39935 18.9333 5.86606 18.9333 6.79948 18.9333ZM11.2161 15.1833C11.2161 15.4134 11.0296 15.5999 10.7995 15.5999C10.5694 15.5999 10.3828 15.4134 10.3828 15.1833C10.3828 14.9532 10.5694 14.7666 10.7995 14.7666C11.0296 14.7666 11.2161 14.9532 11.2161 15.1833Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.ddd2e94c6b8cbbf3a9fa670b41b1642f.svg";
export { ForwardRef as ReactComponent };